import { THSOContact } from '../system/types';
export const ORDER_SET_DATA = 'ORDER_SET_DATA';
export const ORDER_RESET_DATA = 'ORDER_RESET_DATA';
export const ORDER_TOGGLE_LOADING = 'ORDER_TOGGLE_LOADING';
export const ORDER_SET_ACTIVITY = 'ORDER_SET_ACTIVITY';
export const ORDER_ASSIGN_ACTIVITY_IS_OPEN_FIELDS = 'ORDER_ASSIGN_ACTIVITY_IS_OPEN_FIELDS';
export const ORDER_TOGGLE_ACTIVITY_IS_OPEN = 'ORDER_TOGGLE_ACTIVITY_IS_OPEN';
export const ORDER_TOGGLE_ACTIVITY_CONTENT_LOADING = 'ORDER_TOGGLE_ACTIVITY_CONTENT_LOADING';
export const ORDER_SET_ACTIVITY_ERROR = 'ORDER_SET_ACTIVITY_ERROR'

export interface IOrderState {
  loading: boolean;
  loadingActivities: boolean;
  data: TOrder;
}
export type TOrder = {
  orderNumber: string;
  name: string;
  status: string;
  createdOn: string;
  modifiedOn: string;
  orderType: string;
  projectManager: THSOContact;
  products: TProduct[];
  activities: Array<IActivity>;
};
export type TProduct = {
  name: string;
  id: string;
  productNumber: string;
  billingCycle: number;
  status: string;
  createdOn: string;
  modifiedOn: string;
};
export type TEmailAddress = string;
export interface IResetOrderDataAction {
  type: typeof ORDER_RESET_DATA;
}
export interface IEmailAddresses {
  to: TEmailAddress;
  from: any;
  cc?: string;
}
export interface ISetOrderDataAction {
  type: typeof ORDER_SET_DATA;
  data: object;
}
export interface IToggleOrderLoading {
  type: typeof ORDER_TOGGLE_LOADING;
}
export interface IAssignActivityIsOpenFields {
    type: typeof ORDER_ASSIGN_ACTIVITY_IS_OPEN_FIELDS;
}
export interface IToggleOrderActivityContentLoading {
    type: typeof ORDER_TOGGLE_ACTIVITY_CONTENT_LOADING;
    id: string;
}
export interface IAddOrderActivityError {
    type: typeof ORDER_SET_ACTIVITY_ERROR;
    id: string;
    error: string;
}

export interface ISetOrderActivity {
    type: typeof ORDER_SET_ACTIVITY;
    data: IActivity;
}
export interface IActivity {
    id: string;
    type: string;
    createdOn: Record<string, any>;
    modifiedOn: Record<string, any>;
    subject: string;
    status: string;
    content: string;
    createdBy: string;
    emailAddress: Record<string, any>;
    isOpen?: boolean;
    emailAddresses: IEmailAddresses;
    showFullMessage: boolean;
    contentLoading: boolean;
    error?: string;

}

export interface IToggleActivity {
    type: typeof ORDER_TOGGLE_ACTIVITY_IS_OPEN;
    id: string;
}

export type OrderActionTypes =
    ISetOrderDataAction |
    IToggleOrderLoading |
    IResetOrderDataAction |
    IAssignActivityIsOpenFields |
    IToggleActivity |
    IToggleOrderActivityContentLoading |
    ISetOrderActivity |
    IAddOrderActivityError;
